import React from "react";
import {
  ContentPostFragment,
  QueriedResourcePostsSlice,
} from "../../types/graphql";
import {
  ButtonWrapper,
  Headline,
  Posts,
  ResourceButton,
  ResourcesPostsBase,
} from "./resources-posts.styled";
import SmallPostCard from "../small-post-card/small-post-card";
import { SliceComponentProps } from "@prismicio/react";
import { Slice } from "@prismicio/types";
import { IPageContext } from "../../types/types";
import { SharedSliceType } from "../shared-slice/shared-slice";
import { linkTo } from "../../utils/contentUtils";

export type IQueriedResourcesPostsProps = Slice<
  SharedSliceType,
  QueriedResourcePostsSlice["primary"],
  QueriedResourcePostsSlice["items"][number]
> &
  QueriedResourcePostsSlice;

const QueriedResourcesPosts = ({
  slice,
  context,
}: SliceComponentProps<IQueriedResourcesPostsProps, IPageContext>) => {
  const resourcesPosts = context.queriedResourcesPosts?.[
    slice.id
  ] as ContentPostFragment[];
  const headline = slice.primary.headline;
  const buttonLink = slice.primary?.button_link;
  const buttonText = slice.primary?.button_text;
  const hideAuthorName = slice.items && slice.items[0].hide_author_name;

  return (
    (resourcesPosts && (
      <ResourcesPostsBase className="slice-section">
        <div className="container">
          {headline && <Headline>{headline}</Headline>}
          <Posts>
            {resourcesPosts &&
              resourcesPosts.map((post, index) => (
                <SmallPostCard
                  key={index}
                  post={post}
                  hideAuthorName={hideAuthorName}
                />
              ))}
          </Posts>
          {buttonLink && buttonText && (
            <ButtonWrapper>
              <ResourceButton to={linkTo(buttonLink)}>
                {buttonText}
              </ResourceButton>
            </ButtonWrapper>
          )}
        </div>
      </ResourcesPostsBase>
    )) || <></>
  );
};

export default QueriedResourcesPosts;
